export const GUEST_EFS = 'service_efs_external';
